import React, { Component } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@material-ui/core';
import ImageEditor from './ImageEditor';
import AdornedButton from './AdornedButton';

class ImageEditorDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: props.open === undefined ? true : props.open
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.open !== this.props.open) {
      this.setState({ open: this.props.open });
    }
  }

  handleChanges = (type, value) => {
    this.setState({ [type]: value });
  };

  handleClose = () => {
    if (this.props.handleClose) {
      this.props.handleClose();
    }
  };

  handleSave = () => {
    if (this.editor) {
      const canvas = this.editor.getImageScaledToCanvas();
      canvas.toBlob(
        blob => {
          this.props.handleEditorFinish(blob);
        },
        'image/png',
        0.8
      );
    }
  };

  setEditorRef = editor => {
    this.editor = editor;
  };

  render() {
    return (
      <Dialog onClose={this.handleClose} open={this.state.open}>
        <DialogTitle>Editor de Imágenes</DialogTitle>
        <DialogContent dividers>
          <ImageEditor setRef={this.setEditorRef} {...this.props} />
        </DialogContent>
        <DialogActions>
          <AdornedButton
            variant="contained"
            color="primary"
            onClick={() => this.handleSave()}
            disabled={this.props.loading}
            loading={this.props.loading}
          >
            Hecho
          </AdornedButton>
        </DialogActions>
      </Dialog>
    );
  }
}

export default ImageEditorDialog;
